import { useTranslate } from "ra-core";
import { useCallback } from "react";

import { i18nProvider } from "../providers/commons/i18nProvider";
import { formatPersonName, type PersonNameFields } from "./personName";

const UNNAMED_KEY = "crm.common.unnamed";

/**
 * Display name of a contact or user for the UI: full name, else email, else
 * the translated "Sin nombre".
 */
export const usePersonName = (): ((
  person?: PersonNameFields | null,
) => string) => {
  const translate = useTranslate();
  return useCallback(
    (person) =>
      formatPersonName(person, translate(UNNAMED_KEY, { _: "Unnamed" })),
    [translate],
  );
};

/**
 * Same as usePersonName, for the places that cannot call hooks: the resources'
 * `recordRepresentation` (titles, breadcrumbs, reference fields and options).
 * Uses the app's i18nProvider, which follows the current locale.
 */
export const personRepresentation = (
  person?: PersonNameFields | null,
): string =>
  formatPersonName(
    person,
    i18nProvider.translate(UNNAMED_KEY, { _: "Unnamed" }),
  );
